import React, { useState, useEffect} from "react";
import { Container, Row, Col, Card, Table, Spinner } from "react-bootstrap";
import { SYSTEM_DEFAULTS } from "../util/constants";
import HelperFunction from "../util/helper";

export default function Statistics({ preview = false }) {
    const [statistics, setTransactions] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchStatistics = async (page) => {
        try {
          setIsLoading(true);
          setError('');
    
          const response = await fetch(
            `${process.env.REACT_APP_WENGMACK_V1_BE_URL}/statistics?page=${page}&limit=${SYSTEM_DEFAULTS.PAGE_SIZE}`
          );
    
          if (!response.ok) {
            throw new Error('Failed to load statistics');
          }
    
          const data = await response.json();
    
          // API should return: { statistics: [], totalPages: number }
          setTransactions(data.statistics);
          setTotalPages(data.totalPages);
        } catch (err) {
          setError(err.message);
        } finally {
          setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchStatistics(currentPage);
    }, [currentPage]);
    
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <Card className="statistics-card mb-4">
            <Card.Body>
                <div className="card-header-custom">
                <h5>Statistic</h5>
                <select className="filter-select">
                    <option>This Month</option>
                    <option>This Week</option>
                    <option>Today</option>
                </select>
                </div>
                <div className="income-expense-info">
                    <div className="info-item">
                        <span></span>
                        <span></span>
                    </div>
                    <div className="info-item">
                        <span></span>
                        <span></span>
                    </div>
                </div>
                {/* <div className="donut-chart">
                <div className="chart-center">
                    <div className="chart-value">$3,500</div>
                    <div className="chart-label">Net Expense</div>
                </div>
                </div> */}
                {isLoading ? (
                    <div className="d-flex justify-content-center my-5">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <div className="expense-breakdown">
                        {statistics.length > 0 ? (
                            statistics.map((item, index) => (
                                <div key={index} className="breakdown-item">
                                <div className="breakdown-info">
                                    <span className="breakdown-percentage">{item.percentage}%</span>
                                    <span className="breakdown-category">{item.category}</span>
                                </div>
                                <span className="breakdown-amount">{HelperFunction.formatCurrency(item.amount)}</span>
                                </div>
                            ))
                        ): (
                            <p className="text-center">
                                No statistics found.
                            </p>
                        )}
                    </div>
                )}
            </Card.Body>
        </Card>
    )
}